import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import NotFoundImage from '../assets/SVG/404.png'; // Ensure image is optimized for multiple devices

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  // Optimizing the function with useCallback to prevent unnecessary re-renders
  const handleGoBack = useCallback(() => {
    navigate(-1); // Go back to the previous page
  }, [navigate]);

  // Handle navigation to home (optional - could be added back when necessary)
  const handleNavigateHome = useCallback(() => {
    navigate('/admin'); // Navigate to home (or admin)
  }, [navigate]);

  return (
    <Box
      sx={{
        minHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <img
        src={NotFoundImage}
        alt="404 - Page Not Found"
        srcSet={`${NotFoundImage} 300w, ${NotFoundImage} 600w`} // Use srcSet for responsive image loading
        style={{ width: '380px', maxWidth: '90%', marginBottom: '2rem' }}
      />
      <Typography variant="h4" fontWeight="bold" sx={{ marginBottom: '1rem' }}>
        Page Not Found
      </Typography>
      <Typography variant="body1" sx={{ maxWidth: '500px', color: 'text.secondary', marginBottom: '1rem' }}>
        Sorry, the page you are looking for doesn’t exist.
      </Typography>
      <Typography variant="body1" sx={{ maxWidth: '500px', color: 'text.secondary', marginBottom: '2rem' }}>
        It may have been moved, deleted, or you followed a broken link.
        <br />
        Please use the <strong>sidebar</strong> to navigate back.
      </Typography>

      <Button
        variant="contained"
        color="primary"
        onClick={handleGoBack}
        sx={{
          padding: '0.75rem 1.5rem',
          fontWeight: '600',
          fontSize: '1rem',
          marginBottom: '1rem',
        }}
        aria-label="Go back to the previous page"
      >
        Go Back
      </Button>

      <Button
        variant="outlined"
        color="secondary"
        onClick={handleNavigateHome}
        sx={{
          padding: '0.75rem 1.5rem',
          fontWeight: '600',
          fontSize: '1rem',
        }}
        aria-label="Go to home page"
      >
        Return Home
      </Button>
    </Box>
  );
};

export default NotFoundPage;
